import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import moment from 'moment';

import { UploadFile, HelpTooltip } from '@components';
import { AuthService, EmployeeService, SnackbarService } from '@services';
import { Theme, Layout, MUI, Typography } from '@styles';

const HomeExternal = () => {
  return (
    <Layout.Content>
      <Typography.H2>
        <Trans>GenericMessages.welcomeTalentry</Trans>
      </Typography.H2>
    </Layout.Content>
  );
};

class UiGuide extends Component {
  constructor(props) {
    console.log('HOME AUTH', AuthService);
    super(props);
    this.state = {
      isExternal: Boolean(JSON.parse(localStorage.getItem('ls.infoUsuario')).EsExterno),
      date: moment(),
      time: moment(),
      fileObj: [],
    };
  }
  click = () => {
    // SnackbarService.error('ERRORORO');
    // const Snackbar = this.context;

    EmployeeService.getInfo()
      .then((response) => {
        console.log('USER INFO', response);
        SnackbarService.success('Snackbar de EXITO!!');

      })
      .catch((error) => {
        console.log('ERROR', error);
        SnackbarService.error('ERROR');
      });
  };

  click2 = () => {
    // SnackbarService.error('ERRORORO');

    SnackbarService.error('Snackbar de ERROR :(');

  };


  render() {
    const { isExternal } = this.state;

    console.log('HOME', this.props);
    if (isExternal) {
      return (
        <HomeExternal />
      );
    } else {
      return (
        <>
          <Typography.H5>
            COLORS
          </Typography.H5>
          <MUI.Box
            display="flex"
            padding="8px"
          >
            {Object.keys(Theme.colors).map((color) => (
              <Circle
                key={`id-${color}`}
                color={color}
              />
            ))}
          </MUI.Box>

          <br />

          <Typography.H5>
            SHADOWS
          </Typography.H5>
          <MUI.Box
            padding="8px"
            display="flex"
          >
            {Object.keys(Theme.shadows).map((shadow) => (
              <Square
                key={`id-${shadow}`}
                shadow={shadow}
              >
                {shadow}
              </Square>
            ))}
          </MUI.Box>

          <MUI.Box
            padding="8px"
            display="flex"
          >
            <ButtonCTA
              type="button"
              color="primary"
              onClick={this.click}
            >
              Texto
            </ButtonCTA>
            <ButtonFAB
              color="primary"
              onClick={this.click2}
            >
              Texto
            </ButtonFAB>
          </MUI.Box>

          <br />
          <div>
            <HelpTooltip message={'Mensaje del tooltip'} />
          </div>

          <Typography.H5>
            TYPOGRAPHY
          </Typography.H5>
          <MUI.Box padding="8px">
            <Typography.H1>Heading H1</Typography.H1>
            <br />
            <Typography.H2>Heading H2</Typography.H2>
            <br />
            <Typography.H3>Heading H3</Typography.H3>
            <br />
            <Typography.H4>Heading H4</Typography.H4>
            <br />
            <Typography.H5>Heading H5</Typography.H5>
            <br />
            <Typography.H6>Heading H6</Typography.H6>
            <br />
            <Typography.Text>Body Text</Typography.Text>
            <br />
            <Typography.Text><Typography.Small>Small Text</Typography.Small></Typography.Text>
            <br />
            <Typography.Text><Typography.Strong>Strong Text</Typography.Strong></Typography.Text>
            <br />
            <Typography.Text><Typography.Highlight>Highlight Text</Typography.Highlight></Typography.Text>
            <br />
            <Typography.Text><Typography.Italic>Italic Text</Typography.Italic></Typography.Text>
            <br />
            <Typography.Text><Typography.Underline>Underline Text</Typography.Underline></Typography.Text>
          </MUI.Box>
          <br />
          <MUI.Grid container item xs={12} spacing={2}>
            <MUI.Grid item md={4} sm={6} xs={12}>
              <UploadFile
                fileObject={this.state.fileObj}
                formatsAccepted={['application/pdf']}
                formatsMessage="PDF"
                maxSize={1} // 10 MB
                onChangeFile={(file) => this.setState({ fileObj: file })}
              />
            </MUI.Grid>
            <MUI.Grid item md={4} sm={6} xs={12}>
              <MUI.DatePicker
                value={this.state.date}
              // onChange={(newDate) => this.hand(newDate)}
              // format="MMMM/YYYY"
              // mask={'__/_____'}
              />
            </MUI.Grid>
            <MUI.Grid item md={4} sm={6} xs={12}>
              <MUI.TimePicker
                value={this.state.time}
                // onChange={(newDate) => this.hand(newDate)}
                // format="MMMM/YYYY"
                // mask={'__/_____'}
                openTo="hours"
                views={['hours', 'minutes']}
              />
            </MUI.Grid>
          </MUI.Grid>
        </>
      );
    }
  }
}

const ButtonCTA = styled(MUI.ButtonCTA)`
  &.MuiButton-root {
    background-color: #FFF;
    box-shadow: ${(props) => props.theme.shadows.boxDepth1};
    &:hover{
      background-color: #FFF;
      box-shadow: ${(props) => props.theme.shadows.boxDepth2};
    }
  }
`;

const ButtonFAB = styled(MUI.ButtonFAB)`
  &.MuiFab-root {
    box-shadow: ${(props) => props.theme.shadows.depth1};
  }
  &.MuiFab-primary {
    background-color: #FFF;
    &:hover{
      background-color: #FFF;
      box-shadow: ${(props) => props.theme.shadows.depth2};
    }
  }
`;

const Circle = styled.div`
  width: 50px;
  height: 50px;
  margin: 16px;
  border-radius: 50%;
  border: 1px solid #F1F1F1;
  background-color: ${(props) => props.theme.colors[props.color]};
`;

const Square = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 16px;
  border-radius: 6px;
  font-size: 13px;
  box-shadow: ${(props) => props.theme.shadows[props.shadow]};
`;

export default UiGuide;
